import { render, staticRenderFns } from "./ListCalificacion.vue?vue&type=template&id=631f746e&scoped=true"
import script from "./ListCalificacion.vue?vue&type=script&lang=js"
export * from "./ListCalificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631f746e",
  null
  
)

export default component.exports